import { Row, Col, Image } from "antd";
import { Typography, FormControlLabel, Switch, TextField, Tooltip, IconButton } from "@mui/material";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import infoMarkIcon from "../../../../../../assets/images/icon_actions/infoMark.svg";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../../Shared/components/Icons/Date";
import moment from 'moment';


export const HeaderView = (props) => {
    const { classes, clsx, form, error, changeHandler, customerDetails, changeCustomer, view,
        stateDetails, pincodeDetails, countryDetails, areaDetails, cityDetails, customerApi, cashDiscountDetails, taxCodedetails, otherTaxesdetails,
        mopDetails, currencyDetails, partyGstdetails, capitalizeFirstLetter, currencyFormat, status, address, parameterDetails,
        customObject, idNamingConversion, handleIncludeGst, lines } = props;

    return (
        <>
            <Row gutter={50}>
                <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
                    <Row gutter={50}>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Row>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Quote Number</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>{form?.serialNo || '---'} </Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={classes.textAlignRight}>
                                    <span className={clsx(classes.statusButton,
                                        { [classes.submittedButton]: status === 'SUBMITTED' || status === 'RECEIVED' },
                                        { [classes.acceptedButton]: status === 'ACCEPTED' },
                                        { [classes.openButton]: status === 'REJECTED' },
                                        { [classes.reSubmittedButton]: status === 'RESUBMITTED' },
                                        { [classes.cancelledButton]: status === 'CANCELLED' },
                                        { [classes.confirmedButton]: status === 'DELIVERED' || status === 'ORDERED' },
                                        classes.margin20t)}>{status || 'CREATED'}</span>
                                </Col>
                            </Row>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>In-AppTransactions</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.inAppTransition ? 'Yes' : 'No'}</Typography>
                                </> :
                                    <FormControlLabel
                                        classes={{
                                            label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                        }}
                                        control={<Switch size='small'
                                            className={clsx(classes.customSwitch)}
                                            onChange={(e) => changeHandler(!form?.inAppTransition, 'inAppTransition')}
                                        />}
                                        id={idNamingConversion('In-AppTransactions', 'salesQuote', 'Radio')}
                                        label="In-AppTransactions"
                                        labelPlacement="top"
                                        checked={form?.inAppTransition}
                                        disabled={form?.inAppStatus === 'ACCEPTED' ? false : true}
                                        className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                    />
                            }
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Price Includes Tax</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.priceIncludesTax ? 'Yes' : 'No'}</Typography>
                                </> : <FormControlLabel
                                    classes={{
                                        label: clsx(classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom),
                                    }}
                                    id={idNamingConversion('Price Includes Tax', 'salesQuote', 'Radio')}
                                    control={<Switch size='small'
                                        className={clsx(classes.customSwitch)}
                                        onChange={(e) => changeHandler(!form?.priceIncludesTax, 'priceIncludesTax')}
                                    />}
                                    label="Price Includes Tax"
                                    labelPlacement="top"
                                    checked={form?.priceIncludesTax}
                                    disabled={lines?.length > 0 ? true : false}
                                    className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                />
                            }
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Customer Name </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.name || '---'}</Typography>
                                </> :
                                    <AutoCompleteComponent
                                        name={["Customer Name ", <span key={"Customer Name"} className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ 'key': 'name', 'name': 'Customer Name' },
                                        { 'key': 'mobile', 'name': 'Phone Number' },
                                        { 'key': 'serialNo', 'name': 'Customer ID' }]}
                                        details={customerDetails}
                                        id={idNamingConversion('customerName', 'salesQuote', 'DropDown')}
                                        parentValue={customObject(customerDetails, form?.customerId)}
                                        onChange={(data) => changeCustomer(data)}
                                        searchType={(s) => customerApi(s)}
                                        parentError={error?.customerId || false}
                                        position={"bottom"}
                                        customClasses={classes.margin20t}
                                    />
                            }
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Customer ID</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.serialNo || '----'}</Typography>
                                </> : <>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer ID</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer?.serialNo || '----'}</Typography>
                                </>
                            }
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx({ [classes.margin20t]: !view }, { [classes.margin30t]: view }, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Status </Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{capitalizeFirstLetter(status || 'CREATED')}</Typography>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                {
                                    view ?
                                        <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Transaction Date</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form.transactionDate ? moment(form.transactionDate).format('DD MMM YYYY') : '---'}
                                            </Typography>
                                        </> :
                                        <LocalizationProvider
                                            dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                tabIndex={-1}
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={form?.transactionDate || null}
                                                label="Transaction Date"
                                                PopperProps={{
                                                    className: classes.dateAdjust,
                                                }}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        id: idNamingConversion('Transaction Date', 'salesQuote', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                // minDate={new Date(y, m, 1)}
                                                // maxDate={new Date(y, m + 1, 0)}
                                                format="dd/MM/yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError || newValue === null) {
                                                        changeHandler(new Date(), 'transactionDate');
                                                    } else {
                                                        changeHandler(newValue, 'transactionDate');
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                }
                            </div>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                {
                                    view ?
                                        <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Delivery Date</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form.deliveryDate ? moment(form.deliveryDate).format('DD MMM YYYY') : '---'}
                                            </Typography>
                                        </> :
                                        <LocalizationProvider
                                            dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                tabIndex={-1}
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={form?.deliveryDate || null}
                                                label="Delivery Date"
                                                PopperProps={{
                                                    className: classes.dateAdjust,
                                                }}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        error: error?.deliveryDate ? true : false,
                                                        helperText: error?.deliveryDate,
                                                        id: idNamingConversion('Delivery Date', 'salesQuote', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                minDate={form?.transactionDate}
                                                format="dd/MM/yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError || newValue === null) {
                                                        changeHandler(new Date(), 'deliveryDate');
                                                    } else {
                                                        changeHandler(newValue, 'deliveryDate');
                                                    }
                                                }}

                                            />
                                        </LocalizationProvider>
                                }
                            </div>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Phone Number </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.phone || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Phone Number ", <span key={"Phone Number"} className={classes.colorRedRequired}> *</span>]}
                                        fullWidth
                                        //type="number"
                                        name={"phone"}
                                        id={idNamingConversion('Phone Number', 'salesQuote', 'TextField')}
                                        className={clsx(classes.margin20t)}
                                        error={error?.phone && true}
                                        helperText={error?.phone}
                                        variant={'standard'}
                                        value={form?.phone || ''}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                    />
                            }
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Method of Payment (MOP)</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.mop?.method || '---'}</Typography>
                                </> :
                                    <AutoCompleteComponent
                                        name={["Method of Payment (MOP)"]}
                                        heads={[{ 'key': 'method', 'name': 'Method' },
                                        { 'key': 'description', 'name': 'Description' }]}
                                        details={mopDetails}
                                        id={idNamingConversion('Method of Payment (MOP)', 'salesQuote', 'DropDown')}
                                        parentValue={customObject(mopDetails, form?.mopId)}
                                        onChange={(data) => changeHandler(data, 'mopId', true)}
                                        position={"bottom"}
                                        customClasses={classes.margin20t}
                                    />
                            }
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Currency</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.currency?.name || '---'}</Typography>
                                </> :
                                    <AutoCompleteComponent
                                        name={["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ 'key': 'name', 'name': 'Currency Name' },
                                        { 'key': 'shortName', 'name': 'Currency Short Form' }]}
                                        details={currencyDetails}
                                        id={idNamingConversion('Currency', 'salesQuote', 'DropDown')}
                                        parentValue={customObject(currencyDetails, form?.currencyId)}
                                        onChange={(data) => changeHandler(data, 'currencyId', true)}
                                        parentError={error?.currencyId || false}
                                        position={"top"}
                                        customClasses={classes.margin20t}
                                    />
                            }
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Email</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.email || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Email "]}
                                        fullWidth
                                        name={"email"}
                                        id={idNamingConversion('Email', 'salesQuote', 'TextField')}
                                        className={clsx(classes.margin20t)}
                                        variant={'standard'}
                                        value={form?.email || ''}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                    />
                            }
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Reference</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.reference || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label=''
                                        placeholder='Reference'
                                        value={form?.reference}
                                        variant={'outlined'}
                                        className={clsx(classes.customDescription, classes.margin20t)}
                                        fullWidth
                                        multiline
                                        rows={3}
                                        name={"reference"}
                                        disabled={form?.inAppTransition || false}
                                        id={idNamingConversion('Reference', 'salesQuote', 'TextField')}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                    />
                            }
                        </Col>
                        <Col xxl={16} xl={16} lg={16} md={16} sm={16} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Comments</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.comments || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label=''
                                        placeholder='Comments'
                                        value={form?.comments}
                                        variant={'outlined'}
                                        className={clsx(classes.customDescription, classes.margin20t)}
                                        fullWidth
                                        multiline
                                        rows={3}
                                        name={"comments"}
                                        id={idNamingConversion('Comments', 'salesQuote', 'TextField')}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                    />
                            }
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.margin35t, classes.bold)}>GST Details</Typography>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Tax Invoice</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.includeGst ? 'Yes' : 'No'}</Typography>
                                </> :
                                    <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom),
                                        }}
                                        id={idNamingConversion('Tax Invoice', 'salesQuote', 'Radio')}
                                        control={<Switch size='small'
                                            className={clsx(classes.customSwitch)}
                                            onChange={(e) => handleIncludeGst(!form?.includeGst)}
                                        />}
                                        label="Tax Invoice"
                                        labelPlacement="top"
                                        checked={form?.includeGst}
                                        disabled={form?.includeDisabled}
                                        className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                    />
                            }
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Party GST Code</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.partyGst?.code || '---'}</Typography>
                                </> :
                                    <AutoCompleteComponent
                                        name={["Party GST Code "]}
                                        heads={[{ 'key': 'code', 'name': 'Party GST Code' },
                                        { 'key': 'description', 'name': 'Description' }]}
                                        details={partyGstdetails}
                                        id={idNamingConversion('Party GST Code', 'salesQuote', 'DropDown')}
                                        parentValue={customObject(partyGstdetails, form?.partyGstId)}
                                        onChange={(data) => changeHandler(data, 'partyGstId', true)}
                                        parentError={error?.partyGstId}
                                        position={"top"}
                                        customClasses={clsx(classes.margin20t)}
                                    />
                            }
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <div className={clsx(classes.margin20t, classes.dateAdjust)} tabIndex={-1}>
                                {
                                    view ?
                                        <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Valid Date</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form.validDate ? moment(form.validDate).format('DD MMM YYYY') : '---'}
                                            </Typography>
                                        </> :
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={form?.validDate || null}
                                                minDate={form?.transactionDate}
                                                // maxDate={validDate}
                                                label="Valid Date"
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        error: error?.validDate ? true : false,
                                                        helperText: error?.validDate,
                                                        id: idNamingConversion('Valid Date', 'salesQuote', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                //readOnly={true}
                                                format="dd/MM/yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError || newValue === null) {
                                                        changeHandler(new Date(), 'validDate');
                                                    } else {
                                                        changeHandler(newValue, 'validDate');
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                }
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
                    <Row gutter={50} className={clsx(classes.mobileViewSalesCreate)}>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Typography variant={'h6'} style={{ height: 40 }} className={clsx(classes.typographyHeader, classes.typographyHeaderToolTip, classes.bold)}><span>Address</span>
                                <Tooltip
                                    classes={{ popper: classes.customToolTip }}
                                    title={'The Address selected here will determine the Tax Applicable'} arrow placement="top" className={classes.tooltip}>
                                    <IconButton>
                                        <Image src={infoMarkIcon} preview={false} />
                                    </IconButton>
                                </Tooltip>
                            </Typography>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin10t, classes.fonSize13)}>Delivery Name</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.name || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Delivery Name"]}
                                        fullWidth
                                        name={"name"}
                                        id={idNamingConversion('Name', 'salesQuote', 'TextField')}
                                        variant={'standard'}
                                        value={form?.name || ''}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        className={clsx(classes.margin10t)}
                                        onChange={(e) => changeHandler(e)}
                                    />
                            }
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>State</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.state?.name || '---'}</Typography>
                                </> :
                                    <AutoCompleteComponent
                                        name={["State/Province - Place of Supply ", <span key={"State/Province - Place of Supply"} className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ 'key': 'name', 'name': 'State Name' },
                                        { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                        details={stateDetails}
                                        id={idNamingConversion('State', 'salesQuote', 'DropDown')}
                                        parentValue={customObject(stateDetails, form?.stateId)}
                                        onChange={(data) => changeHandler(data, 'stateId', true)}
                                        position={"bottom"}
                                        customClasses={clsx(classes.margin20t)}
                                        parentError={error?.stateId || false}
                                    />
                            }
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Country</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.country?.name || '---'}</Typography>
                                </> :
                                    <AutoCompleteComponent
                                        name={["Country"]}
                                        heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                        details={countryDetails}
                                        id={idNamingConversion('Country', 'salesQuote', 'DropDown')}
                                        parentValue={customObject(countryDetails, form?.countryId)}
                                        onChange={(data) => changeHandler(data, 'countryId', true)}
                                        position={"bottom"}
                                        customClasses={classes.margin20t}
                                    />
                            }
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Pincode</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.pincode?.code || '---'}</Typography>
                                </> :
                                    <AutoCompleteComponent
                                        name={["Pincode ", <span key={"Pincode"} className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ 'key': 'code', 'name': 'Pincode' }, { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                        details={pincodeDetails}
                                        id={idNamingConversion('Pincode', 'salesQuote', 'DropDown')}
                                        parentValue={customObject(pincodeDetails, form?.pincodeId)}
                                        onChange={(data) => changeHandler(data, 'pincodeId', true)}
                                        position={"bottom"}
                                        customClasses={classes.margin20t}
                                        parentError={error?.pincodeId || false}
                                    />
                            }
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Dist/City/Town</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.city?.name || '---'}</Typography>
                                </> :
                                    <AutoCompleteComponent
                                        name={["Dist/City/Town"]}
                                        heads={[{ 'key': 'name', 'name': 'Name' },
                                        { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                        details={cityDetails}
                                        id={idNamingConversion('City', 'salesQuote', 'DropDown')}
                                        parentValue={customObject(cityDetails, form?.cityId)}
                                        onChange={(data) => changeHandler(data, 'cityId', true)}
                                        position={"top"}
                                        customClasses={classes.margin20t}
                                    />
                            }
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Area</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.area?.name || '---'}</Typography>
                                </> :
                                    <AutoCompleteComponent
                                        name={["Area"]}
                                        heads={[{ 'key': 'name', 'name': 'Area Name' },
                                        { 'key': 'pincode', 'name': 'Pincode', 'relation': 'code' },
                                        { 'key': 'city', 'name': 'City', 'relation': 'name' },
                                        { 'key': 'state', 'name': 'State', 'relation': 'shortName' }]}
                                        details={areaDetails}
                                        id={idNamingConversion('Area', 'salesQuote', 'DropDown')}
                                        parentValue={customObject(areaDetails, form?.areaId)}
                                        onChange={(data) => changeHandler(data, 'areaId', true)}
                                        position={"top"}
                                        customClasses={classes.margin20t}
                                        customLink={'/admin/address/area'}
                                        linkText={'Go to Area'}
                                        infoMark={'Select the local postal area from the list or Goto Area master to create a new record for the missing area info. The field is optional and will take blank values.'}
                                    />
                            }
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={clsx(classes.mobileAreaAddress)}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Address Line 1</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.address1 || '---'}</Typography>
                                </> :
                                    <div className={clsx(classes.margin20t, classes.positionRelative)}>
                                        <TextField autoComplete='one-time-code'
                                            label=''
                                            placeholder='Door/Building Number,&#10;Building Name&#10;Street Address&#10;Locality'
                                            value={form?.address1 || address}
                                            variant={'outlined'}
                                            className={clsx(classes.customDescription)}
                                            fullWidth
                                            multiline
                                            rows={3}
                                            name={"address1"}
                                            id={idNamingConversion('Address', 'salesQuote', 'TextField')}
                                            InputProps={{
                                                classes: {
                                                    input: clsx(classes.textFieldColor),
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        // disabled={lines?.length > 0 ? true : false}
                                        />
                                        {/* <div className={classes.customIcon}>
                                            <NavLink to={`#`} >
                                                <Image src={EditIcon} preview={false} />
                                            </NavLink>
                                        </div> */}
                                    </div>
                            }
                        </Col>
                    </Row>

                </Col>
            </Row>
            <Row gutter={50}>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Totals</Typography>
                </Col>
                {parameterDetails?.salesValue &&
                    <Col span={16}>
                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Sales Total</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lines?.length > 0 ? lines?.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.salesValue || 0), 0) : 0)}</Typography>
                    </Col>
                }
                <Col span={16}>
                    <Row gutter={50}>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Total Discount</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.totalDiscount || 0)}</Typography>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Net Amount</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.netAmount || 0)}</Typography>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                <span>GST Amount </span>
                                <Tooltip tabIndex={-1}
                                    classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                    title={'Rounded to 2 decimal places'} arrow placement="top"
                                    className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                    <IconButton>
                                        <Image src={infoMarkIcon} preview={false} />
                                    </IconButton>
                                </Tooltip> </Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.gstAmount || 0)}</Typography>
                        </Col>
                    </Row>
                </Col>
                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                    <Row gutter={50}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={8} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Round Off</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {capitalizeFirstLetter(form?.roundOffMethod || 'BLANK')} - ₹ {currencyFormat(form?.roundOffAmount || 0)}</Typography>
                                </> : <Row>
                                    <Col xxl={8} xl={10} lg={10} md={8} sm={6} xs={6}>
                                        <AutoCompleteComponent
                                            name={["Round Off"]}
                                            heads={[{ 'key': 'name', 'name': 'Name' }]}
                                            details={[{ id: '', name: 'Blank' }, { id: 'UP', name: 'Up' }, { id: 'DOWN', name: 'Down' }]}
                                            id={idNamingConversion('Round off', 'salesQuote', 'DropDown')}
                                            parentValue={customObject([{ id: '', name: 'Blank' }, { id: 'UP', name: 'Up' }, { id: 'DOWN', name: 'Down' }], form?.roundOffMethod)}
                                            onChange={(data) => changeHandler(data?.id, 'roundOffMethod')}
                                            position={"bottom"}
                                            customClasses={classes.margin20t}
                                        />
                                    </Col>
                                    <Col xxl={16} xl={14} lg={14} md={16} sm={18} xs={18}>
                                        <TextField autoComplete='one-time-code'
                                            label={[""]}
                                            fullWidth
                                            type="number"
                                            id={idNamingConversion('Round Off Amount', 'salesQuote', 'TextField')}
                                            className={clsx(classes.margin20t)}
                                            error={error?.roundOffAmount && true}
                                            helperText={error?.roundOffAmount}
                                            variant={'standard'}
                                            name="roundOffAmount"
                                            value={form.roundOffAmount}
                                            InputProps={{
                                                classes: {
                                                    input: clsx(classes.textFieldColor, classes.padding10L)
                                                }
                                            }}
                                            inputProps={{
                                                step: "any",
                                                "aria-autocomplete": "none"
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom
                                            }}
                                            disabled={form?.roundOffMethod ? false : true}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                    </Col>
                                </Row>
                            }
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={8} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Invoice Amount</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.invoiceAmount || 0)}</Typography>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row gutter={50}>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                </Col>
                <Col span={16}>
                    <Row gutter={50}>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Cash Discount</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {capitalizeFirstLetter(form?.cashDiscount?.code || '---')} - ₹ {currencyFormat(form?.cashDiscountAmount || 0)}</Typography>
                                </> : <Row gutter={20}>
                                    <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                        <AutoCompleteComponent
                                            name={["Cash Discount"]}
                                            heads={[{ 'key': 'code', 'name': 'Code' }]}
                                            details={cashDiscountDetails || []}
                                            id={idNamingConversion('Cash Discount', 'salesQuote', 'DropDown')}
                                            parentValue={customObject(cashDiscountDetails || [], form?.cashDiscountId)}
                                            onChange={(data) => changeHandler(data, 'cashDiscountId', true)}
                                            position={"bottom"}
                                            customClasses={classes.margin20t}
                                        />
                                    </Col>
                                    <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Amount</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.cashDiscountAmount || 0)}</Typography>
                                    </Col>
                                </Row>
                            }
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Excise Amount</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.excisesAmount || 0)}</Typography>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Assessable Value</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.assessableValue || 0)}</Typography>
                        </Col>
                    </Row>
                </Col>
                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                    <Row gutter={50}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={8} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Tax Code</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {capitalizeFirstLetter(form?.taxCode?.code || '---')} - ₹ {currencyFormat(form?.tax || 0)}</Typography>
                                </> : <Row gutter={20}>
                                    <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                        <AutoCompleteComponent
                                            name={["Tax Code"]}
                                            heads={[{ 'key': 'code', 'name': 'Code' }]}
                                            details={taxCodedetails || []}
                                            id={idNamingConversion('Tax Code', 'salesQuote', 'DropDown')}
                                            parentValue={customObject(taxCodedetails || [], form?.taxCodeId)}
                                            onChange={(data) => changeHandler(data, 'taxCodeId', true)}
                                            position={"bottom"}
                                            customClasses={classes.margin20t}
                                        />
                                    </Col>
                                    <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.tax || 0)}</Typography>
                                    </Col>
                                </Row>
                            }
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={8} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>TCS</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {capitalizeFirstLetter(form?.tcsName?.name || '---')} - ₹ {currencyFormat(form?.tcs || 0)}</Typography>
                                </> : <Row gutter={20}>
                                    <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                        <AutoCompleteComponent
                                            name={["TCS"]}
                                            heads={[{ 'key': 'name', 'name': 'Name' }]}
                                            details={(otherTaxesdetails || []).filter(el => el.taxType === 'TCS')}
                                            id={idNamingConversion('TCS', 'salesQuote', 'DropDown')}
                                            parentValue={customObject((otherTaxesdetails || []).filter(el => el.taxType === 'TCS'), form?.tcsNameId)}
                                            onChange={(data) => changeHandler(data, 'tcsNameId', true)}
                                            position={"bottom"}
                                            disabled={!form?.customer?.tcsBoolean}
                                            customClasses={classes.margin20t}
                                        />
                                    </Col>
                                    <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.tcs || 0)}</Typography>
                                    </Col>
                                </Row>
                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}